export const scrollTo = (elementOffsetTop: number) => {
  window.scrollTo(
    {
      top: elementOffsetTop,
      behavior: 'smooth'
    }
  )
}
